import React, { useState, useContext } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import Alert from '@material-ui/lab/Alert';
import {
    Button, Dialog, DialogActions,
    DialogContent, DialogTitle,
    Grid, Slide, Typography
} from '@material-ui/core';

import { DispatchContext } from '../../../../context/Provider';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const JoinClassForm = (props) => {

    const appDispatch = useContext(DispatchContext);
    const { globalDispatch } = appDispatch;

    const [classroom, setClassroom] = useState({classcode: ''});
    const [customErrorMessage, setCustomErrorMessage] = useState(null);

    const [joinError, setJoinError] = useState(null)

    async function joinClass(values, resetForm) {

        setCustomErrorMessage(null)

        const joinRequestResponse = await axiosConfig.post(`/request-to/joinClass`, {
            classcode: values.classcode
        });

        if (joinRequestResponse.data.status_code === 'CLASSROOM_NOT_FOUND') {
            setCustomErrorMessage(joinRequestResponse.data.message)
        }

        if (joinRequestResponse.data.status_code === 'ok') {
            globalDispatch({type: 'setSnackbarMsg', value: joinRequestResponse.data.message});
            globalDispatch({type: 'setIsOpenSnackbar', value: true});
            props.handleClose();
            props.fetchClassrooms();
        } else {
            setCustomErrorMessage(joinRequestResponse.data.message);
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={'sm'}
            TransitionComponent={Transition}
            disableBackdropClick
        >
            <Formik
                initialValues={classroom}
                validate={(values) => {

                    const errors = {};
                    if (!values.classcode) {
                        errors.classcode = 'This field is required';
                    }

                    return errors;
                }}
                onSubmit={(values, {setSubmitting, errors, resetForm}) => {
                    setSubmitting(false);
                    globalDispatch({type: 'setIsLoading', value: true});

                    joinClass(values, resetForm);
                }}
            >
                {({submitForm, isSubmitting, touched, errors}) => (
                    <Form>
                        <DialogTitle id="form-dialog-title">
                            {props.dialogTitle}
                        </DialogTitle>
                        <DialogContent>
                            <Grid container alignItems="flex-start" spacing={2}>

                                {customErrorMessage && (
                                    <Grid item xs={12}>
                                        <Alert variant="filled" severity="error" style={{width: '100%'}}>
                                            <Typography>
                                                {customErrorMessage}
                                            </Typography>
                                        </Alert>
                                    </Grid>
                                )}

                                <Grid item xs={12}>
                                    <Field
                                        component={TextField}
                                        label="Classcode (required)"
                                        name="classcode"
                                        fullWidth
                                        variant="outlined"
                                        autoComplete="off"
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={props.handleClose}
                                disabled={isSubmitting}
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            <Button
                                disabled={isSubmitting}
                                onClick={submitForm} color="primary"
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}

export default JoinClassForm;